import get from "lodash/get";

import NotificationService from "../services/notification.service";
import InternalInvoicesService from "../services/internal-invoices.service";
import { BACKEND_PROCESSING_ONGOING } from "./types";
import { markInvoiceAsProcessed, handleBulkErrorMessage } from "./invoices.actions";
import { INVOICE_SERVICES } from "../components/Invoices/constants";

export const bulkDeleteInvoices = (references, isAllRecordsSelected, params = {}) => async (dispatch, getState) => {
  const tenantSlug = get(getState(), "common.currentTenant.slug");

  dispatch({ type: BACKEND_PROCESSING_ONGOING, isBackendProcessingOngoing: isAllRecordsSelected });

  const deleteInvoiceResponses = Promise.allSettled(
    references.map(invoiceId => {
      if (!isAllRecordsSelected) dispatch(markInvoiceAsProcessed(invoiceId));
      return InternalInvoicesService.delete(tenantSlug, invoiceId, params);
    })
  );

  deleteInvoiceResponses.then(results => {
    const failures = results.filter(response => response.status === "rejected");

    if (failures.length > 0) {
      if (!isAllRecordsSelected) {
        failures.forEach(failure => {
          handleBulkErrorMessage(failure, "deleting", dispatch, INVOICE_SERVICES.INTERNAL_INVOICES);
        });
      } else {
        NotificationService.addError(`Delete ${failures.length} of ${references.length} invoice(s) failed!`, {
          autoClose: false
        });
      }
    } else {
      NotificationService.addSuccess(`Successfully deleted ${references.length} invoice(s)`, { autoClose: false });
    }

    dispatch({ type: BACKEND_PROCESSING_ONGOING, isBackendProcessingOngoing: false });
  });
};

export const promoteInProgressInvoices = (references, params) => async (dispatch, getState) => {
  const tenantSlug = get(getState(), "common.currentTenant.slug");

  try {
    references.forEach(invoiceId => dispatch(markInvoiceAsProcessed(invoiceId)));
    await InternalInvoicesService.promote(tenantSlug, { customerIds: references, ...params });
    NotificationService.addSuccess("Invoices were successfully promoted");
  } catch (e) {
    NotificationService.addError(`Could not promote invoices. ${NotificationService.handleMessage(e)}`);
  }
};
